<template>
    <div class="coniten">
        <div class="item">
            <div class="item-title">
                <div style="font-size: 15px;font-weight: bold;color: #333333;">小蝌蚪找妈妈</div>
                <div style="font-size: 13px;color: #999999;">20201-12-12 23:12</div>
            </div>
            <div class="item-title" style="margin:30px 0 15px">
                <div style="font-size: 14px;color: #999999;">作品类型</div>
                <div>课件</div>
            </div>
            <div class="item-title">
                <div style="font-size: 14px;color: #999999;">问题类型</div>
                <div>标题有误 / 内容有误</div>
            </div>
            <div class="item-title" style="margin-top:15px;height:56px;">
                <div style="font-size: 14px;color: #999999;">问题详情</div>
                <div>这是建议的详细内容这是建议的详细内</div>
            </div>
            <div style="font-size: 14px;color: #999999;display:flex;">相关图片</div>
            <div class="imgList">
                <div class="img-item"></div>
                <div class="img-item"></div>
                <div class="img-item"></div>
                <div class="img-item"></div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data () {
        return {
    
        };
    },
    methods:{
    
    }
}
</script>
<style scoped lang="scss">    
.coniten{
    height: 100vh;
    background: #F8F8F8;
    padding-top: 15px;
}
.item{
    width: 85%;
    margin: auto;
    height: 323px;
    background: #fff;
    border-radius: 8px;
    padding: 14px 15px;
}
.item-title{
    height: 25px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    color: #333;
}
.imgList{
    margin-top: 15px;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    .img-item{
        width: 70px;
        height: 70px;
        border-radius: 5px;
        background:#ccc;
        margin-right:10px;
    }
}
</style>